
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[coachUsername]/join",
      function () {
        return require("private-next-pages/[coachUsername]/join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[coachUsername]/join"])
      });
    }
  